import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) { console.error("Section crashed", error); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="border border-traffic-red p-4 text-sm" data-testid={this.props.testid || "section-error"}>
        <p className="font-medium">{this.props.title || "This section could not be shown."}</p>
        <p className="text-muted-foreground mt-1">{String(this.state.error?.message || this.state.error).slice(0, 200)}</p>
        <button className="mt-2 underline text-xs" onClick={() => this.setState({ error: null })}>Try again</button>
      </div>
    );
  }
}
